export const emailRegex = /^[A-Za-z0-9._%+'&-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,7}$/;
export const isEmailInvalid = (email: string) => {
  return email ? !emailRegex.test(email) : false;
};
